import React, {
  FC, useCallback, useContext, useState,
} from 'react';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Popover from '@material-ui/core/Popover';

import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import SearchIcon from '@material-ui/icons/Search';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import HistoryIcon from '@material-ui/icons/History';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import PersonIcon from '@material-ui/icons/Person';

import firebase from 'firebase/app';
import { useHistory } from 'react-router';
import AuthContext from '@/context/auth';
import { UserRoleEnum } from '@/types/user';
import ROUTES from '@/constants/routes';
import _ from 'lodash';
// import { useResize } from '@/utils';
import { MakeType } from '@/types/search';
import useStyles from './style';
import Search from '../Search';

type HeaderProps = {
  makeData: MakeType[];
}

const Header: FC<HeaderProps> = ({
  makeData,
}) => {
  const classes = useStyles();
  const history = useHistory();

  const [auth] = useContext(AuthContext);

  // const { width } = useResize();

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleLogOut = useCallback(() => {
    history.replace(ROUTES.HOME);
    firebase.auth().signOut();
  }, [history]);

  const handleGo = useCallback((path: string) => () => {
    history.push(path);
  }, [history]);

  const handleClosePopover = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  const handleOpenPopover = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  }, [setAnchorEl]);

  return (
    <header className={classes.root}>
      <Container className={classes.content}>
        <button type="button" className={classes.logo} onClick={handleGo(ROUTES.HOME)}>Skipadealer</button>
        {
          auth ? (
            <div className={classes.controls}>
              <div className={classes.controlItemContainer}>
                {
                  !!_.intersection(auth?.roles, [UserRoleEnum.Manager, UserRoleEnum.Admin]).length && (
                    <div className={classes.controlItem}>
                      <Button onClick={handleGo(ROUTES.MANAGER_PANEL_USER)}>
                        <SupervisorAccountIcon />
                        <span>Manager panel</span>
                      </Button>
                    </div>
                  )
                }
                <div className={classes.controlItem}>
                  <Button onClick={handleGo(ROUTES.HOW_IT_WORKS)}>
                    <span>How it works</span>
                  </Button>
                </div>
                <div className={classes.controlItem}>
                  <Button onClick={handleGo(ROUTES.SEARCH_LIST)}>
                    <HistoryIcon />
                    <span>History</span>
                  </Button>
                </div>
                <div className={classes.controlItem}>
                  <Button onClick={handleGo(ROUTES.FAVORITES)}>
                    <FavoriteBorderIcon />
                    <span>Favorites</span>
                  </Button>
                </div>
                <Popover
                  open={Boolean(anchorEl)}
                  onClose={handleClosePopover}
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  className={classes.searchWrap}
                >
                  <Search
                    className={classes.search}
                    closePopup={handleClosePopover}
                    makeData={makeData}
                  />
                </Popover>
                <div className={classes.controlItem}>
                  <Button onClick={handleOpenPopover}>
                    <SearchIcon />
                    <span>Search</span>
                  </Button>
                </div>
                <div className={classes.controlItem}>
                  <Button onClick={handleGo(ROUTES.USER_PROFILE)}>
                    <PersonIcon />
                    <span>Profile</span>
                  </Button>
                </div>
                <div className={classes.controlItem}>
                  <Button onClick={handleLogOut}>
                    <ExitToAppIcon />
                    <span>Sign out</span>
                  </Button>
                </div>
              </div>
              {/* <span className={classes.email}>{email}</span> */}
            </div>
          ) : (
            <div className={classes.controls}>
              <div className={classes.controlItemContainer}>
                <div className={classes.controlItem}>
                  <Button onClick={handleGo(ROUTES.HOW_IT_WORKS)}>
                    <span>How it works</span>
                  </Button>
                </div>
                <div className={classes.controlItem}>
                  <Button onClick={handleGo(ROUTES.SIGN_IN)}>
                    <ExitToAppIcon />
                    <span>Sign In</span>
                  </Button>
                </div>
              </div>
            </div>
          )
        }
      </Container>
    </header>
  );
};

export default Header;
